import React from "react";
//import Button from "react-bootstrap/Button";
import { Button } from "antd";

import "./ButtonComponent.css";

const ButtonComponent = (props) => {
  return (
    <Button
      className={props.className}
      style={props.style}
      active={props.active}
      size={props.size}
      block={props.block}
      icon={props.icon}
      id={props.id}
      onClick={props.onClick}
      htmlType={props.type}
      type={props.variant || "primary"}
      value={props.value}
      disabled={props.disabled}
      loading={props.loading}
    >
      {props.children}
    </Button>
  );
};

export default ButtonComponent;
